import React, { useEffect } from "react";

import { PRODUCT_CATEGORIES } from "@/mock";
import { CategoryCard } from "@/pages/_bits";
import { Container, setTitle } from "@/pages/_shared";

export default function ProductsPage() {
  useEffect(() => setTitle("Products"), []);

  return (
    <div>
      <section className="py-14">
        <Container>
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight">Products</h1>
          <p className="mt-4 text-base text-muted-foreground max-w-2xl">
            Explore categories and open any product detail page for typical specification ranges, features, applications and RFQ options.
          </p>

          <div className="mt-10 grid gap-6 lg:grid-cols-3">
            {PRODUCT_CATEGORIES.map((c) => (
              <CategoryCard key={c.id} c={c} />
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
